import '@organisms/message-form';

import { defineElement, FC, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { addAlert } from '@source/store/alert';

const MessageFormInline: FC = () => {
    const [successMessage] = useProp<string>('successMessage');
    const [contactReason] = useProp<string>('contactReason', '');
    const [complaintTypes] = useProp<string>('complaintTypes', '');

    function onSuccess() {
        addAlert(successMessage);
    }

    return (
        <message-form
            onSuccess={onSuccess}
            {...(contactReason && { contactReason })}
            {...(complaintTypes && { complaintTypes: JSON.parse(complaintTypes) })}
        />
    );
};

MessageFormInline.props = {
    successMessage: {
        type: String,
        required: true,
    },
    contactReason: {
        type: String,
        reflectToAttr: true,
    },
    complaintTypes: {
        type: String,
    },
};

defineElement('message-form-inline', MessageFormInline);
